import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import './loading-layer.scss';

const LoadingLayer = (props: { content: any }) => {
  const { content } = props;
  console.log('content', content);
  return (
    <div className="loading-layer">
      {content != 'Session left...' &&
        content != 'You have ended the Session...' &&
        content != 'You have left the Session...' &&
        content != 'You have been removed by the Host...' &&
        content != 'This meeting has been ended by the Host...' && (
          <LoadingOutlined style={{ fontSize: '86px', color: '#fff' }} />
        )}
      <p className="loading-text">{content}</p>
    </div>
  );
};

export default LoadingLayer;
